<template>
  <div id="exchangeDetail">
    <div class="ui text container">
      <div v-if="type === 'transfer'">
        <h2 class="ui header">件名：{{title}}</h2>
        <h4 class="ui top attached block header">宛先</h4>
        <div class="ui attached segment">
          <div :key="index" v-for="(address, index) in addresses">{{address}}</div>
        </div>
        <h4 class="ui attached block header">コメント（ファイル内容の補足）</h4>
        <div class="ui bottom attached segment newline-wrap">{{comments}}</div>
      </div>
      <div v-if="type === 'pickup'">
        <h2 class="ui header">件名：{{title}}</h2>
        <h4 class="ui top attached block header">宛先</h4>
        <div class="ui attached segment">
          <div :key="index" v-for="(address, index) in addresses">{{address}}</div>
        </div>
        <h4 class="ui attached block header">依頼者コメント</h4>
        <div class="ui bottom attached segment newline-wrap">{{comments}}</div>
        <h4 class="ui attached block header">添付者コメント</h4>
        <div class="ui bottom attached segment newline-wrap">{{unsigned_comments}}</div>
      </div>
      <table class="ui table" id="exchangeDetail-fileTable">
        <thead>
          <tr class="single line">
            <th width="30px">No.</th>
            <th>ファイル名</th>
            <th>ファイルサイズ</th>
            <th width="200px">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td class="exchangeDetail-fileTable__no">{{index + 1}}</td>
            <td class="exchangeDetail-fileTable__fileName newline-wrap">{{item.name}}</td>
            <td class="exchangeDetail-fileTable__fileSize">{{item.size | bytes}}</td>
            <td class="exchangeDetail-fileTable__operation">
              <button
                class="ui button blue tiny exchangeDetail-fileTable__download"
                v-bind:class="{disabled: isExpired}"
                @click="downloadFile(item.file_id, item.name)"
              >ダウンロード</button>
              <button
                class="ui button orange tiny exchangeDetail-fileTable__delete"
                v-bind:class="{disabled: isExpired}"
                @click="deleteFile(item.file_id, item.name)"
              >削除</button>
            </td>
          </tr>
        </tbody>
      </table>
      <table id="exchangeDetail-duration" class="ui very basic table">
        <tbody>
          <tr>
            <td id="exchangeDetail-duration__exchangeId" class="right aligned">交換ID：</td>
            <td>{{exchangeId}}</td>
          </tr>
          <tr>
            <td id="exchangeDetail-duration__upload" class="right aligned">アップロード日時：</td>
            <td v-show="status !== 'requesting'">{{uploadedDate | datetime}}</td>
            <td v-show="status === 'requesting'"></td>
          </tr>
          <tr>
            <td id="exchangeDetail-duration__expiration" class="right aligned">ダウンロード期限：</td>
            <td v-show="status !== 'requesting'">{{expireDate | datetime}}</td>
            <td v-show="status === 'requesting'"></td>
          </tr>
        </tbody>
      </table>
      <div></div>
    </div>
    <router-link
      tag="button"
      id="exchangeDetail-back"
      class="ui button gray"
      :to="{ name: 'exchangeList' }"
    >戻る</router-link>
  </div>
</template>

<script>
import {
  getUploadedFiles,
  downloadUploadedFile,
  deleteUploadedFile
} from '@/api'
import { compareName } from '@/common'

export default {
  title: '交換履歴詳細',
  data: function () {
    return {
      exchangeId: '',
      items: [],
      title: '-',
      addresses: [],
      expireDate: '',
      uploadedDate: '',
      comments: '-',
      unsigned_comments: '-',
      type: '',
      status: ''
    }
  },
  created: function () {
    this.$store.commit('progress/setLoading', true)
    this.init()
  },
  methods: {
    /** 初期化 */
    init: function () {
      const exchangeId = this.$route.params.exchange_id
      getUploadedFiles(exchangeId)
        .then(response => {
          this.exchangeId = response.exchange_id
          this.title = response.title
          this.addresses = response.addresses
          this.uploadedDate = response.uploaded_date
          this.expireDate = response.expire_date
          this.comments = response.comments
          this.unsigned_comments = response.unsigned_comments
          this.type = response.type
          this.status = response.status
          this.items = response.files
          this.items.sort(compareName)
          this.$store.commit('progress/setLoading', false)
        })
        .catch(err => {
          console.log(err)
          this.$store.commit('progress/setLoading', false)
          this.$store.commit('infoModal/openModal', {
            type: 'ERROR',
            title: 'ファイル交換履歴詳細取得',
            message:
              '通信エラーが発生しました。\nしばらくしてからもう一度お試しください。'
          })
        })
    },

    /** ファイルをダウンロードする */
    downloadFile: function (fileId, fileName) {
      this.$store.commit('progress/setLoading', true)
      downloadUploadedFile(this.exchangeId, fileId)
        .then(response => {
          this.$store.commit('progress/setLoading', false)
          if (window.navigator.msSaveOrOpenBlob) {
            /* IEの場合 */
            navigator.msSaveBlob(new Blob([response.data]), fileName)
          } else {
            /* IE以外(Chrome, Firefox) */
            const link = document.createElement('a')
            link.setAttribute(
              'href',
              window.URL.createObjectURL(new Blob([response.data]))
            )
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            link.remove()
          }
        })
        .catch(err => {
          console.log(err)
          this.$store.commit('progress/setLoading', false)
          this.$store.commit('infoModal/openModal', {
            type: 'ERROR',
            title: 'ファイルダウンロード',
            message:
              '通信エラーが発生しました。\nしばらくしてからもう一度お試しください。'
          })
        })
    },

    /** ファイルIDにて削除する */
    deleteFile: function (fileId, fileName) {
      const self = this
      this.$store.commit('confirmModal/openModal', {
        title: 'アップロードファイルの削除',
        message: `アップロードされているファイル「${fileName}」を削除します。\nよろしいですか？`,
        executeLabel: '削除',
        callback: function (answer) {
          if (answer) {
            self.$store.commit('progress/setLoading', true)
            deleteUploadedFile(self.exchangeId, fileId)
              .then(() => {
                if (self.items.length === 1) {
                  // ファイルをすべて削除するとファイル交換自体削除されるため、一覧に戻る
                  self.$router.push({ name: 'exchangeList' })
                } else {
                  self.init()
                }
              })
              .catch(err => {
                console.log(err)
                self.$store.commit('progress/setLoading', false)
                self.$store.commit('infoModal/openModal', {
                  type: 'ERROR',
                  title: 'ファイル削除',
                  message:
                    '通信エラーが発生しました。\nしばらくしてからもう一度お試しください。'
                })
              })
          }
        }
      })
    }
  },
  computed: {
    isExpired: function () {
      return new Date(this.expireDate).valueOf() < Date.now()
    }
  }
}
</script>

<style>
#exchangeDetail {
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
}

.item-title {
  font-weight: bolder;
  text-align: end;
}

.ui.bottom.attached.segment {
  margin-bottom: 0px;
}
</style>
